const UserWishlist =()=> {
  return (
    <div>
      your wish list is here
    </div>
  );
};

export default UserWishlist;
